<template>
    <div class="row mb-3" v-if="canExport">
        <div class="col-12 ">
            <div class="card mb-3">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body text-elev-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <p class="text-2xl mb-0"><strong>{{ $t('Eksporter timeoversikt') }}</strong></p>
                        </div>
                        <div class="hr-wrapper">
                            <hr>
                        </div>
                        <div class="card-body pt-1">

                            <button class="btn px-5 mb-2 btn-info fw-bold" @click="download" :disabled="isGenerating">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isGenerating"></span>
                                {{ $t('Eksporter til PDF') }}
                            </button>

                            <p>{{ $t('Klikk på timene du ønsker å eksportere. Hvis ingen er valgt eksporteres hele timeoversikten.') }}</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/teachingCardStore';

const isGenerating = computed(() => Store.isGeneratingExport());
const canExport = computed(() => Store.getStudentClassId())

function download() {
    Store.runExport();
}
</script>
